import { useContext } from 'react';
import type { IRoadmapPageContextProps } from './roadmap-page-context';
import { roadmapPageContext } from './roadmap-page-context';

export function useRoadmapPageContext(): IRoadmapPageContextProps {
    const context = useContext(roadmapPageContext);
    if (context == null) throw new Error('useRoadmapPageContext must be used within the <RoadmapContextProvider>');

    return context;
}
